// Source/Consent-Button/Component.ts
class ConsentButton extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const { signal } = this.controller;
    this.link.addEventListener("click", (event) => {
      event.stopImmediatePropagation();
      this.openConsentMenu();
    }, {
      capture: true,
      signal
    });
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  openConsentMenu() {
    window.__cmp?.("showScreenAdvanced");
  }
  get link() {
    return this.querySelector(`a`);
  }
}

// Source/Consent-Button/mod.ts
customElements.define("consent-button", ConsentButton);
